export const amazon_bedrockModels = {
    id: "amazon-bedrock",
    name: "Amazon Bedrock",
    npm: "@ai-sdk/amazon-bedrock",
    doc: "https://docs.aws.amazon.com/bedrock/latest/userguide/models-supported.html",
    env: ["AWS_ACCESS_KEY_ID", "AWS_SECRET_ACCESS_KEY", "AWS_REGION"],
    models: {
        "anthropic.claude-3-5-sonnet-20241022-v2:0": {
            id: "anthropic.claude-3-5-sonnet-20241022-v2:0",
            name: "Claude Sonnet 3.5 v2",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "cohere.command-light-text-v14": {
            id: "cohere.command-light-text-v14",
            name: "Command Light",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-08",
            release_date: "2023-11-01",
            last_updated: "2023-11-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.3,
                output: 0.6,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "anthropic.claude-opus-4-1-20250805-v1:0": {
            id: "anthropic.claude-opus-4-1-20250805-v1:0",
            name: "Claude Opus 4.1",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "meta.llama3-1-70b-instruct-v1:0": {
            id: "meta.llama3-1-70b-instruct-v1:0",
            name: "Llama 3.1 70B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.72,
                output: 0.72,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "anthropic.claude-3-haiku-20240307-v1:0": {
            id: "anthropic.claude-3-haiku-20240307-v1:0",
            name: "Claude Haiku 3",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-02",
            release_date: "2024-03-13",
            last_updated: "2024-03-13",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 1.25,
            },
            limit: {
                context: 200000,
                output: 4096,
            },
        },
        "meta.llama3-2-3b-instruct-v1:0": {
            id: "meta.llama3-2-3b-instruct-v1:0",
            name: "Llama 3.2 3B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-09-25",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.15,
            },
            limit: {
                context: 131000,
                output: 4096,
            },
        },
        "anthropic.claude-3-opus-20240229-v1:0": {
            id: "anthropic.claude-3-opus-20240229-v1:0",
            name: "Claude Opus 3",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-08",
            release_date: "2024-02-29",
            last_updated: "2024-02-29",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
            },
            limit: {
                context: 200000,
                output: 4096,
            },
        },
        "cohere.command-text-v14": {
            id: "cohere.command-text-v14",
            name: "Command",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-08",
            release_date: "2023-11-01",
            last_updated: "2023-11-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.5,
                output: 2,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "meta.llama4-scout-17b-instruct-v1:0": {
            id: "meta.llama4-scout-17b-instruct-v1:0",
            name: "Llama 4 Scout 17B Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.17,
                output: 0.66,
            },
            limit: {
                context: 3500000,
                output: 16384,
            },
        },
        "amazon.nova-micro-v1:0": {
            id: "amazon.nova-micro-v1:0",
            name: "Nova Micro",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-03",
            last_updated: "2024-12-03",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.035,
                output: 0.14,
                cache_read: 0.00875,
            },
            limit: {
                context: 128000,
                output: 8192,
            },
        },
        "amazon.nova-premier-v1:0": {
            id: "amazon.nova-premier-v1:0",
            name: "Nova Premier",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-03",
            last_updated: "2024-12-03",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2.5,
                output: 12.5,
            },
            limit: {
                context: 1000000,
                output: 16384,
            },
        },
        "anthropic.claude-v2": {
            id: "anthropic.claude-v2",
            name: "Claude 2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-08",
            release_date: "2023-07-11",
            last_updated: "2023-07-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 8,
                output: 24,
            },
            limit: {
                context: 100000,
                output: 4096,
            },
        },
        "anthropic.claude-3-7-sonnet-20250219-v1:0": {
            id: "anthropic.claude-3-7-sonnet-20250219-v1:0",
            name: "Claude Sonnet 3.7",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-02-19",
            last_updated: "2025-02-19",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "ai21.jamba-1-5-mini-v1:0": {
            id: "ai21.jamba-1-5-mini-v1:0",
            name: "Jamba 1.5 Mini",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-15",
            last_updated: "2024-08-15",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.4,
            },
            limit: {
                context: 256000,
                output: 4096,
            },
        },
        "meta.llama3-8b-instruct-v1:0": {
            id: "meta.llama3-8b-instruct-v1:0",
            name: "Llama 3 8B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-03",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.3,
                output: 0.6,
            },
            limit: {
                context: 8192,
                output: 2048,
            },
        },
        "ai21.jamba-1-5-large-v1:0": {
            id: "ai21.jamba-1-5-large-v1:0",
            name: "Jamba 1.5 Large",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2024-08-15",
            last_updated: "2024-08-15",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2,
                output: 8,
            },
            limit: {
                context: 256000,
                output: 4096,
            },
        },
        "anthropic.claude-opus-4-20250514-v1:0": {
            id: "anthropic.claude-opus-4-20250514-v1:0",
            name: "Claude Opus 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "meta.llama3-70b-instruct-v1:0": {
            id: "meta.llama3-70b-instruct-v1:0",
            name: "Llama 3 70B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2.65,
                output: 3.5,
            },
            limit: {
                context: 8192,
                output: 2048,
            },
        },
        "meta.llama4-maverick-17b-instruct-v1:0": {
            id: "meta.llama4-maverick-17b-instruct-v1:0",
            name: "Llama 4 Maverick 17B Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.24,
                output: 0.97,
            },
            limit: {
                context: 1000000,
                output: 16384,
            },
        },
        "amazon.nova-pro-v1:0": {
            id: "amazon.nova-pro-v1:0",
            name: "Nova Pro",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-03",
            last_updated: "2024-12-03",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 3.2,
                cache_read: 0.2,
            },
            limit: {
                context: 300000,
                output: 8192,
            },
        },
        "anthropic.claude-sonnet-4-20250514-v1:0": {
            id: "anthropic.claude-sonnet-4-20250514-v1:0",
            name: "Claude Sonnet 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "anthropic.claude-3-5-haiku-20241022-v1:0": {
            id: "anthropic.claude-3-5-haiku-20241022-v1:0",
            name: "Claude Haiku 3.5",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 4,
                cache_read: 0.08,
                cache_write: 1,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "amazon.nova-lite-v1:0": {
            id: "amazon.nova-lite-v1:0",
            name: "Nova Lite",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-12-03",
            last_updated: "2024-12-03",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.06,
                output: 0.24,
                cache_read: 0.015,
            },
            limit: {
                context: 300000,
                output: 8192,
            },
        },
        "meta.llama3-2-1b-instruct-v1:0": {
            id: "meta.llama3-2-1b-instruct-v1:0",
            name: "Llama 3.2 1B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-09-25",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.1,
            },
            limit: {
                context: 131000,
                output: 4096,
            },
        },
        "cohere.command-r-plus-v1:0": {
            id: "cohere.command-r-plus-v1:0",
            name: "Command R+",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2024-04-04",
            last_updated: "2024-04-04",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 3,
                output: 15,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "anthropic.claude-instant-v1": {
            id: "anthropic.claude-instant-v1",
            name: "Claude Instant",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-08",
            release_date: "2023-03-01",
            last_updated: "2023-03-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 2.4,
            },
            limit: {
                context: 100000,
                output: 4096,
            },
        },
        "meta.llama3-1-8b-instruct-v1:0": {
            id: "meta.llama3-1-8b-instruct-v1:0",
            name: "Llama 3.1 8B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.22,
                output: 0.22,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "anthropic.claude-3-5-sonnet-20240620-v1:0": {
            id: "anthropic.claude-3-5-sonnet-20240620-v1:0",
            name: "Claude Sonnet 3.5",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2024-06-20",
            last_updated: "2024-06-20",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "cohere.command-r-v1:0": {
            id: "cohere.command-r-v1:0",
            name: "Command R",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2024-03-11",
            last_updated: "2024-03-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 1.5,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "meta.llama3-3-70b-instruct-v1:0": {
            id: "meta.llama3-3-70b-instruct-v1:0",
            name: "Llama 3.3 70B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.72,
                output: 0.72,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "meta.llama3-2-11b-instruct-v1:0": {
            id: "meta.llama3-2-11b-instruct-v1:0",
            name: "Llama 3.2 11B Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-09-25",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.16,
                output: 0.16,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "anthropic.claude-v2:1": {
            id: "anthropic.claude-v2:1",
            name: "Claude 2.1",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-08",
            release_date: "2023-11-21",
            last_updated: "2023-11-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 8,
                output: 24,
            },
            limit: {
                context: 200000,
                output: 4096,
            },
        },
        "meta.llama3-2-90b-instruct-v1:0": {
            id: "meta.llama3-2-90b-instruct-v1:0",
            name: "Llama 3.2 90B Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-09-25",
            last_updated: "2024-09-25",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.72,
                output: 0.72,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "anthropic.claude-3-sonnet-20240229-v1:0": {
            id: "anthropic.claude-3-sonnet-20240229-v1:0",
            name: "Claude Sonnet 3",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-08",
            release_date: "2024-03-04",
            last_updated: "2024-03-04",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
            },
            limit: {
                context: 200000,
                output: 4096,
            },
        },
        "deepseek.r1-v1:0": {
            id: "deepseek.r1-v1:0",
            name: "DeepSeek-R1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2025-01-20",
            last_updated: "2025-05-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.35,
                output: 5.4,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
    },
};
export default amazon_bedrockModels;
//# sourceMappingURL=amazon-bedrock.js.map